import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { Footer } from '../components/Footer';
import { DicesIcon, ClockIcon, ShieldCheckIcon, GlassWaterIcon, SparklesIcon, UsersIcon } from 'lucide-react';
const features = [{
  icon: DicesIcon,
  title: 'Modernste Automaten',
  desc: 'Über 50 topaktuelle Spielautomaten verschiedener Hersteller für maximale Unterhaltung.'
}, {
  icon: SparklesIcon,
  title: 'Exklusives Ambiente',
  desc: 'Stilvolles Interieur mit Las-Vegas-Flair – eine einzigartige Atmosphäre direkt an der A9.'
}, {
  icon: GlassWaterIcon,
  title: 'Getränkeservice',
  desc: 'Genießen Sie kostenlose Getränke während des Spiels an unserer Bar.'
}, {
  icon: UsersIcon,
  title: 'Freundliches Personal',
  desc: 'Unser geschultes Team steht Ihnen jederzeit für Fragen und Wünsche zur Verfügung.'
}];
const stagger = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function CasinoPage() {
  return <>
      <PageHeader title="Las Vegas Casino" subtitle="Spannung pur – direkt an der Autobahn." image="https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=1200&q=80" accentColor="text-transparent bg-clip-text bg-gradient-to-r from-white to-neon-purple/80" accentGlow="bg-neon-purple" data-id="element-360" />

      <section className="py-20 px-4 bg-base" data-id="element-361">
        <div className="max-w-7xl mx-auto" data-id="element-362">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-3xl mb-20" data-id="element-363">
            <h2 className="text-4xl font-heading font-bold mb-6 text-gray-900" data-id="element-364">
              Las Vegas feeling – mitten in Bayern
            </h2>
            <p className="text-lg text-gray-500 leading-relaxed mb-6" data-id="element-365">
              Tauchen Sie ein in eine Welt voller Spannung und Entertainment.
              Unser Casino bietet modernste Spielautomaten, ein exklusives
              Ambiente und den perfekten Ausgleich nach einer langen Fahrt auf
              der Autobahn.
            </p>
            <p className="text-lg text-gray-500 leading-relaxed" data-id="element-366">
              Ob kurzer Zwischenstopp oder ausgedehnter Abend – bei uns erleben
              Sie Casino-Unterhaltung auf höchstem Niveau. Lassen Sie den Alltag
              hinter sich und genießen Sie die einzigartige Atmosphäre.
            </p>
          </motion.div>

          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{
          once: true
        }} className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-20" data-id="element-367">
            {features.map(f => {
            const Icon = f.icon;
            return <motion.div key={f.title} variants={fadeUp} className="glass-card p-8 rounded-2xl" data-id="element-368">
                  <div className="w-12 h-12 rounded-xl bg-neon-purple/10 flex items-center justify-center mb-5" data-id="element-369">
                    <Icon className="w-6 h-6 text-neon-purple" strokeWidth={1.5} data-id="element-370" />
                  </div>
                  <h3 className="text-xl font-heading font-bold mb-2 text-gray-900" data-id="element-371">
                    {f.title}
                  </h3>
                  <p className="text-gray-500" data-id="element-372">{f.desc}</p>
                </motion.div>;
          })}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="glass-card p-8 rounded-2xl border-neon-purple/20 max-w-xl" data-id="element-373">
            <div className="flex items-center gap-3 mb-4" data-id="element-374">
              <ClockIcon className="w-5 h-5 text-neon-purple" data-id="element-375" />
              <h3 className="text-xl font-heading font-bold text-gray-900" data-id="element-376">
                Öffnungszeiten
              </h3>
            </div>
            <p className="text-gray-700 mb-4" data-id="element-377">
              Täglich geöffnet: 11:00 – 03:00 Uhr
            </p>
            <div className="flex items-center gap-3 mb-2" data-id="element-378">
              <ShieldCheckIcon className="w-5 h-5 text-neon-purple" data-id="element-379" />
              <p className="text-gray-500 text-sm" data-id="element-380">
                Zutritt ab 18 Jahren. Bitte Ausweis mitbringen.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-381" />
    </>;
}